/* stylelint-disable no-descending-specificity */
import styled, { css } from "styled-components"

const linkStyles = css`
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 2rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  margin-right: 2.4rem;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const StyledIcon = styled.div`
  width: auto;
  height: 1.6rem;
  display: inline-block;
  margin-right: 0.4rem;

  & svg {
    width: auto;
    height: 100%;
    fill: ${({ theme }) => theme.color.secondary02};

    * {
      fill: inherit;
      transition: inherit;
    }
  }
`
const tabTextStyles = css`
  ${linkStyles};
  color: ${({ theme }) => theme.color.secondary02};

  transition: color 0.5s;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.color.secondary01};
  }
`

const tabItemStyles = css`
  ${linkStyles};
  margin-right: 1.6rem;
  position: relative;

  p {
    display: none;
  }

  &.active,
  &:hover {
    & p {
      display: inline-block;
      color: ${({ theme }) => theme.color.secondary01};
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      bottom: -1.3rem;
      width: 100%;
      height: 0.2rem;
      background: ${({ theme }) => theme.color.main03};
    }
    & svg {
      fill: ${({ theme }) => theme.color.secondary01};
    }
  }

  ${({ theme }) => theme.mq.medium} {
    & svg {
      transition: fill 0.5s;
    }
    p {
      display: inline-block;
    }

    &.active,
    &:hover {
      color: ${({ theme }) => theme.color.secondary01};

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: -1.3rem;
        width: 100%;
        height: 0.2rem;
      }
      & svg {
        fill: ${({ theme }) => theme.color.secondary01};
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }
`

const StyledNavList = styled.div`
  /* sticky on mobile */
  position: sticky;
  top: 0;
  ${({ bannerHeight }) =>
    css`
      top: ${bannerHeight}px;
    `}
  z-index: 89;
  background: ${({ theme }) => theme.color.white};

  display: flex;
  justify-content: space-between;
  margin: 2.4rem 0 0;
  padding: 1.2rem ${({ theme }) => theme.layout.mobilePadding};

  border-top: 0.1rem solid ${({ theme }) => theme.color.secondary04};
  border-bottom: 0.1rem solid ${({ theme }) => theme.color.secondary04};

  ${({ theme }) => theme.mq.medium} {
    position: relative;
    z-index: initial;
    border-top: 0;
    align-items: flex-end;
    margin: 0 0 2rem;
    padding: 0 0 1.2rem;
    top: 0;
  }
`

export { tabItemStyles, tabTextStyles, StyledIcon, StyledNavList }
